<template>
  <div class="grid-tiles">
    <Item v-for="(plugin, n) in plugins" :key="n" class="grid-tile" :item="plugin"/>
  </div>
</template>

<script>
import api from "../../../api";
import Item from "./Item";
import * as JsSearch from 'js-search';

export default {
  async created() {
    await this.updatePlugins()
  },
  data() {
    return {
      plugins: []
    }
  },
  computed: {
    type() {
      return this.$store.state.plugins.type;
    },
    search() {
      return this.$store.state.plugins.search;
    },
  },
  methods: {
    async updatePlugins() {
      const plugins = await api.getAllPlugins(this.type)
      if (this.search !== "") {
        const search = new JsSearch.Search('_id');
        search.addIndex('description')
        search.addIndex('name')
        search.addDocuments(plugins.data)
        this.plugins = search.search(this.search).reverse()
      } else {
        this.plugins = plugins.data.reverse()
      }
    },
  },
  components: {
    Item
  },
  watch: {
    type: async function (_) {
      await this.updatePlugins()
    },
    search: async function (_) {
      await this.updatePlugins()
    },
  }
};
</script>